module.exports = __webpack_public_path__ + "static/media/fruits_2.0ce90c9d.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_2.csv
// module id = 684
// module chunks = 0